import { createSelector } from 'reselect';

// Config
import {
  getIsMultiBatchClearabee,
  getIsMultiBatchCutterAndSquidge,
  getIsMultiBatchFlowers,
  getIsSingleBatchClearabee,
  getIsSingleBatchCutterAndSquidge,
  getIsSingleBatchFlowers,
} from '@redux/reducers/delivery/deliverySelector';

export default createSelector(
  [
    getIsSingleBatchClearabee,
    getIsMultiBatchClearabee,
    getIsSingleBatchCutterAndSquidge,
    getIsMultiBatchCutterAndSquidge,
    getIsSingleBatchFlowers,
    getIsMultiBatchFlowers,
  ], (
    isSingleBatchClearabee,
    isMultiBatchClearabee,
    isSingleBatchCutterAndSquidge,
    isMultiBatchCutterAndSquidge,
    isSingleBatchFlowers,
    isMultiBatchFlowers,
  ) => ({
    isSingleBatchClearabee,
    isMultiBatchClearabee,
    isSingleBatchCutterAndSquidge,
    isMultiBatchCutterAndSquidge,
    isSingleBatchFlowers,
    isMultiBatchFlowers,
  }),
);
